import React from 'react'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import Layout from 'src/components/layouts'
import AboutPage from 'src/components/pages/BrandPages/About'
import { getMegamenuData } from 'src/common/back/megamenu'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'

export async function getServerSideProps(context) {
  let megamenuData = null
  try {
    megamenuData = await getMegamenuData(context)
  } catch (error) {}

  const jsonLdSchemas = await getContentfulJsonLd('about/')

  return {
    props: {
      megamenuData: megamenuData || null,
      jsonLdSchemas,
    },
  }
}

const About = ({ megamenuData, jsonLdSchemas }) => (
  <>
    <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
    <Layout isBrandPage={true} megamenuData={megamenuData}>
      <AboutPage />
    </Layout>
  </>
)

export default About
